import type { ErrorResponse } from '../schemas';
import { isObject } from '../utils/isObject/isObject';

export type FieldErrorResponse = {
  code: string;
  message: string;
  name: string;
  response: {
    data: Record<string | 'non_field_errors', string>;
    status: number;
    statusText: string;
  };
};

export const isFieldErrorResponse = (error: unknown): error is FieldErrorResponse => {
  return (
    error instanceof Error &&
    'response' in error &&
    isObject(error.response) &&
    isObject(error.response.data) &&
    Object.keys(error.response.data).length > 0 &&
    !('detail' in error.response.data)
  );
};

export type ApiErrorResponse = {
  code: string;
  message: string;
  name: string;
  response: {
    data: ErrorResponse;
    status: number;
    statusText: string;
  };
};
export const isApiFormError = (error: unknown): error is ApiErrorResponse => {
  return (
    error instanceof Error &&
    'response' in error &&
    isObject(error.response) &&
    isObject(error.response.data) &&
    Object.keys(error.response.data).length > 0 &&
    'detail' in error.response.data
  );
};

export const isApiError = (error: unknown): error is ErrorResponse => {
  return isObject(error) && 'detail' in error;
};

export type NetworkErrorResponse = {
  code?: string;
  message?: string;
  name?: string;
  isAxiosError?: boolean;
};

export const isNetworkError = (error: unknown): error is NetworkErrorResponse => {
  if (!(error instanceof Error) || !isObject(error)) {
    return false;
  }

  const errorRecord = error as Record<string, unknown>;
  const errorCode = typeof errorRecord.code === 'string' ? errorRecord.code : undefined;

  return error.message === 'Network Error' || errorCode === 'ERR_NETWORK';
};
